import logo from './logo.svg';
// import "./assets/importedCss/bootstrap.min.css"
import './App.css';
import Navbar from './appShell/Navbar/Navbar';
import MainContainer from './appShell/MainContainer/MainContainer';
import "react-toastify/dist/ReactToastify.css";
import "../src/assets/css/bootstrap/css/bootstrap.min.css";
import "./assets/importedCss/css/structure.css"
// import "./assets/importedCss/css/plugins.css"
import "./assets/importedCss/css/scrollspyNav.css"
import "./assets/importedCss/css/dashboard/dash_2.css"
import "./assets/importedCss/css/authentication/form-1.css"
// import "./assets/importedCss/css/apps/mailing-chat.css"
import "./assets/importedCss/css/scrollspyNav.css"
import "./assets/importedCss/css/components/tabs-accordian/custom-accordions.css"
import "./assets/importedCss/css/main.css"

import { ToastContainer, toast } from 'react-toastify';
import { useIdleTimer } from 'react-idle-timer'
import { useState } from 'react';
import { logout_user } from './services/http';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';



function App() {


  const dispatch = useDispatch();
  const states = useSelector((state) => state, shallowEqual);

  const onPrompt = () => {
    // Fire a Modal Prompt
    // console.log("on Prompt")
  }

  const onIdle = () => {
    // Close Modal Prompt
    // Do some idle action like log out your user
    console.log("on Idle")
    // console.log(states.userToken)
    if (Object.keys(states.userToken).length !== 0) { handleSignOut() }
  }

  const onActive = (event) => {
    // Close Modal Prompt
    // Do some active action
    // console.log("on Active ", event)
  }

  const onAction = (event) => {
    // Do something when a user triggers a watched event
    // console.log("onAction ", event)
  }


  const {
    start,
    reset,
    activate,
    pause,
    resume,
    isIdle,
    isPrompted,
    isLeader,
    getTabId,
    getRemainingTime,
    getElapsedTime,
    getLastIdleTime,
    getLastActiveTime,
    getTotalIdleTime,
    getTotalActiveTime
  } = useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    onAction,
    timeout: 1000 * 60 * 15,
    promptTimeout: 0,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange'
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    name: 'idle-timer',
    syncTimers: 0,
    leaderElection: false
  })

  const handleSignOut = async () => {
    let logout_response = await logout_user(states.userToken.access_token)
    console.log(logout_response)
    if (logout_response.response && logout_response.response.statut !== 200) {
      console.log(logout_response.response)
      toast.error(logout_response.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT
      });
    } else {
      console.log(logout_response)
      toast.success("Déconnexion pour inactivité !", {
        position: toast.POSITION.TOP_RIGHT,
        className: 'rotateY animated'
      });

      localStorage.removeItem(`persist:root`);
      localStorage.clear()
      // rootReducer(states, {})
      // dispatch({
      //     type: "SET",
      //     key: "userInfo",
      //     payload: {}
      // })
      // dispatch({
      //     type: "SET",
      //     key: "userToken",
      //     payload: {},
      // });

      // dispatch({
      //     type: "SET",
      //     key: "lastUnreadNotifList",
      //     payload: [],
      // });
      // dispatch({
      //     type: "SET",
      //     key: "unreadNotifList",
      //     payload: [],
      // });

      //   states = undefined;
      // window.location.replace("/auth")
    }

    dispatch({
      type: "SET",
      key: "userInfo",
      payload: {}
    })
    dispatch({
      type: "SET",
      key: "userToken",
      payload: {},
    });
    localStorage.removeItem(`persist:root`);
    //   dispatch({
    //     type: "SET",
    //     key: "idleMessage",
    //     payload: "Veuillez vous reconnecter pour période d'inactivité...",
    // });
    states = undefined;
    // setTimeout(() => {
      window.location.replace("/auth")
    // }, 4500);
  }


  return (
    <div className="App">
      <ToastContainer />
      <MainContainer
      />

    </div>
  );
}

export default App;
